import { Link as MuiLink, LinkTypeMap } from '@mui/material';
import { DefaultComponentProps } from '@mui/material/OverridableComponent';
import * as React from 'react';

export type UnstyledLinkProps = {
  href: string;
  children: React.ReactNode;
} & React.ComponentPropsWithRef<'a'>;

const Link = React.forwardRef<
  HTMLAnchorElement,
  UnstyledLinkProps & DefaultComponentProps<LinkTypeMap>
>(({ children, href, ...rest }, ref) => {
  return (
    <MuiLink
      ref={ref}
      target='_blank'
      rel='noopener noreferrer'
      underline='always'
      href={href}
      {...rest}
    >
      {children}
    </MuiLink>
  );
});

export default Link;
